import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const loginUser = async (values) => {
    const response = await axiosAgent.post(ApiConfig.auth.login, values);
    return response;
};

export const multiRegister = async (formData) => {
    const response = await axiosAgent.post(
        ApiConfig.auth.multiRegister,
        formData
    );
    return response;
};
